/**
 * isFreshEnoughForModal.js — single source of truth for the
 * "should the backlog fee modal auto-open for this job?" freshness rule.
 *
 * A job that reached `awaiting_confirmation` HOURS ago (e.g. an
 * abandoned session on another device) must NOT ambush the user with a
 * modal on every reload. It should still be visible in passive surfaces
 * (banner, uploads list) so the user can act on it deliberately, just
 * not auto-popped.
 *
 * The threshold is intentionally colocated with the caller sites via
 * this helper, so every place that opens the backlog dialog uses the
 * same rule. Callers: `GlobalUploadBacklogModalProvider`,
 * `BankFeedCenterPage.resumePollingForActiveJobs`,
 * `BankFeedCenterPage.contextBridgeEffect`.
 */

export const AUTO_OPEN_MAX_AGE_MS = 30 * 60 * 1000; // 30 minutes

/**
 * @param {{ startedAt?: string, created_at?: string }} job
 * @returns {boolean} true if the job's start time is within the window
 *                    for auto-opening the backlog modal.
 */
export function isFreshEnoughForModal(job) {
  if (!job) return false;
  const src = job.startedAt || job.created_at;
  if (!src) return false;
  const started = Date.parse(src);
  if (!Number.isFinite(started)) return false;
  return (Date.now() - started) <= AUTO_OPEN_MAX_AGE_MS;
}
